import React from 'react';
import { classNames } from '@utils/class-names';

interface AppWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const AppWrapper: React.FC<AppWrapperProps> = ({ children, className }) => {
  return (
    <div className={classNames('w-full', className)}>
      {children}
    </div>
  );
};

export default AppWrapper;
